module.exports = __webpack_public_path__ + "media/images/athletes/2098-ff5f81f3d32ebb5f57bf010b90ba40b3.png";